module.exports = __webpack_public_path__ + "img/logo-rt.d54fd0d1.png";